module.exports = __webpack_public_path__ + "static/media/ship-image-croped.3da5e652.jpeg";